import { Button, Col, FlexboxGrid, Grid, Row } from 'rsuite'
import { useParams } from 'react-router-dom'
import PortalHeader from '../components/layout/PortalHeader'
import { useDispatch, useSelector } from 'react-redux'
import ReportingHistory from '../components/singlePermit/reportingHistory/ReportingHistory'
import PropertyContacts from '../components/singlePermit/propertyContacts/PropertyContacts'
import { selectConfigExpressTaxEnabled } from '../store/slices/config/configSelectors'
import Header from '../components/singlePermit/Header'
import React, { useEffect } from 'react'
import { getReportingHistoryByApplicationNumberAsync } from '../store/slices/licenseView/licenseViewThunks'
import usePlaceNavigate from '../hooks/usePlaceNavigate'
import { resetUpdateState } from '../store/slices/update/updateSlice'
import { resetRenewState } from '../store/slices/renew/renewSlice'

const SinglePermit = () => {
    const { applicationNumber } = useParams();

    const dispatch = useDispatch();
    const placeNavigate = usePlaceNavigate();

    const taxEnabled = useSelector(selectConfigExpressTaxEnabled);

    useEffect(() => {
        dispatch(getReportingHistoryByApplicationNumberAsync(applicationNumber));
        dispatch(resetUpdateState());
        dispatch(resetRenewState());
    }, [dispatch, applicationNumber]);

    return (
        <main>
            <FlexboxGrid justify='space-between'>
                <FlexboxGrid.Item colspan={24}>
                    <PortalHeader title="Single Permit View" />
                </FlexboxGrid.Item>

                <FlexboxGrid.Item colspan={24}>
                    <Grid fluid className="ph-24 pb-24 sm-page-padding">
                        <Row className='mt-24'>
                            <Col xs={24}>
                                <Button appearance="subtle" className='btn-link-underline-hover' onClick={() => { placeNavigate("/dashboard"); }}>&lt; Back</Button>
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: "50px" }}>
                            <Col xs={24}>
                                <Header applicationNumber={applicationNumber} />
                            </Col>
                        </Row>
                        <Row gutter={45}>
                            <Col xs={24} lg={8} lgPush={16}>
                                <PropertyContacts applicationNumber={applicationNumber} />
                            </Col>
                            {
                                taxEnabled && (
                                    <Col xs={24} lg={16} lgPull={8}>
                                        <ReportingHistory applicationNumber={applicationNumber} />
                                    </Col>
                                )
                            }
                        </Row>
                    </Grid>
                </FlexboxGrid.Item>
            </FlexboxGrid>
        </main>
    )
}

export default SinglePermit;
